<template>
  <div class="header-controls-group">
    <LanguageSwitcher :compact="compact" />
    <ThemeToggle :compact="compact" />
  </div>
</template>

<script setup>
// Groups the language switcher and theme toggle so every page that needs
// both header controls only has to add one component. To add a future
// control (e.g. sound toggle), add it here rather than editing every view.
import LanguageSwitcher from './LanguageSwitcher.vue'
import ThemeToggle from './ThemeToggle.vue'

defineProps({
  compact: { type: Boolean, default: false },
})
</script>

<style scoped>
.header-controls-group {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}
</style>
